/**
 * Choisit une couleur de texte lisible (blanc ou encre) pour un fond donné.
 * Utilisé par les chips de tags dont la couleur est libre (choisie par
 * l'utilisateur) : blanc sur jaune clair était illisible.
 */
export function readableTextColor(bgColor: string): string {
  const hex = bgColor.trim().replace(/^#/, '');
  const full =
    hex.length === 3
      ? hex
          .split('')
          .map((c) => c + c)
          .join('')
      : hex;
  if (!/^[0-9a-fA-F]{6}$/.test(full)) return '#ffffff';

  const [r, g, b] = [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16) / 255);
  // Luminance relative (sRGB, WCAG)
  const lin = (c: number) => (c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4);
  const luminance = 0.2126 * lin(r!) + 0.7152 * lin(g!) + 0.0722 * lin(b!);

  // Seuil pragmatique : les rouges/bleus saturés gardent du blanc, les
  // jaunes/verts clairs passent en encre foncée.
  return luminance > 0.3 ? '#1f2937' : '#ffffff';
}
